import * as React from 'react';
import _get from 'lodash/get';
import DeleteCircle from '../../ui/SVG/common/DeleteCircle';
import AccordionTitle from './AccordionTitle/AccordionTitle';
// md3: the legacy MUI ExpansionPanel is replaced by fe-main's md3 delegate (same prop surface)
import ExpansionPanel from '../../ui/ExpansionPanel/ExpansionPanel';
import { PriceRating } from '@bytebrand/fe-ui-core-autobahn/compat';
import { priceRatings } from '@bytebrand/fe-ui-core-autobahn/constants';
import { getFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './PriceReviewModal.styl';
class PriceReviewModal extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "getFormatedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ratingName, valueName) => {
                const { ratingConfig } = this.props;
                const value = _get(ratingConfig, `${ratingName}.${valueName}`, '???');
                return Number.isFinite(value) ? getFormattedPrice(value) : value;
            }
        });
        Object.defineProperty(this, "onClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { hideModal } = this.props;
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                hideModal('PRICE_REVIEW_MODAL');
            }
        });
        Object.defineProperty(this, "renderCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { criteria } = this.props;
                return criteria.map((criteriaItem, i) => (React.createElement("div", { className: styles.criteriaRow, key: i },
                    React.createElement("span", null, criteriaItem.title),
                    React.createElement("span", null, criteriaItem.value))));
            }
        });
        Object.defineProperty(this, "renderCategories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                return [...priceRatings].reverse().map((ratingName, i) => {
                    const min = this.getFormatedValue(ratingName, 'min');
                    const max = this.getFormatedValue(ratingName, 'max');
                    return (React.createElement("div", { className: styles.categoryRow, key: ratingName },
                        React.createElement("div", { className: styles.categoryHeader },
                            React.createElement(PriceRating, { t: t, i18nPrefix: 'priceReview.', rating: priceRatings.length - i - 1 }),
                            React.createElement("span", null, `${min} - ${max} EUR`)),
                        React.createElement("span", { className: styles.categoryDescription }, t(`modals:priceReview.${ratingName}Description`))));
                });
            }
        });
        Object.defineProperty(this, "getAccordionItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                return [
                    {
                        title: React.createElement(AccordionTitle, { title: t('modals:priceReview.criteriaTitle') }),
                        content: React.createElement(React.Fragment, null, this.renderCriteria())
                    },
                    {
                        title: React.createElement(AccordionTitle, { title: t('modals:priceReview.ratingCategoriesTitle') }),
                        content: React.createElement(React.Fragment, null, this.renderCategories())
                    }
                ];
            }
        });
    }
    render() {
        const { t, make, model, rating, currentSalesPrice, currentSalesPricePredicted } = this.props;
        const savingPotential = Number.parseFloat(`${currentSalesPricePredicted}`) - Number.parseFloat(`${currentSalesPrice}`);
        const accordionItems = [
            {
                title: t('modals:priceReview.criteriaTitle'),
                content: React.createElement(React.Fragment, null, this.renderCriteria())
            },
            {
                title: t('modals:priceReview.ratingCategoriesTitle'),
                content: React.createElement(React.Fragment, null, this.renderCategories())
            }
        ];
        return (React.createElement("div", { className: styles.priceReviewModal },
            React.createElement("header", { className: styles.header },
                React.createElement(DeleteCircle, { className: styles.deleteButton, onClick: this.onClose }),
                React.createElement("h2", { className: styles.title }, t('modals:priceReview.title', { make, model }))),
            React.createElement("div", { className: styles.topSection },
                React.createElement("div", null,
                    React.createElement("div", { className: styles.topRow },
                        React.createElement("span", null, t('modals:priceReview.priceOffer')),
                        React.createElement("span", null, getFormattedPrice(currentSalesPrice, undefined, ' €'))),
                    React.createElement("div", { className: styles.topRow },
                        React.createElement("span", null, t('modals:priceReview.marketValue')),
                        React.createElement("span", null, rating === 0 ? 'N/A' : getFormattedPrice(currentSalesPricePredicted, undefined, ' €')))),
                React.createElement(PriceRating, { t: t, i18nPrefix: 'priceReview.', rating: rating, className: styles.priceRating })),
            React.createElement("div", { className: styles.topSectionSpecial },
                React.createElement("div", { className: styles.topRow },
                    React.createElement("span", null, t('modals:priceReview.savingPotential')),
                    React.createElement("span", null, !!rating && savingPotential > 0 ? getFormattedPrice(savingPotential, undefined, ' €') : 'N/A'))),
            accordionItems.map((section) => {
                return (React.createElement(ExpansionPanel, { className: styles.accordion, reactScrollClassName: styles.accordionWrapper, key: section.title, title: section.title }, section.content));
            })));
    }
}
export default PriceReviewModal;
